export const environment = {
    production: true,
    sentry: "https://c01b73b3bd862393d9f3b7e1fe15af43@o4508081201020928.ingest.de.sentry.io/4508970407428176",
    sentryBackendURL: ["/^https:\\/\\/\\.internal\\.solar-sky\\.eu\\/api\\/.*/"]
};
export const baseUrl = "https://internal.solar-sky.eu"
export const integUrl = "https://internal.solar-sky.eu"